import React, { useState, useEffect } from "react"
import { Card } from "reactstrap"
import Loader from "pages/Separate/Loader"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import AssessmentPopulationTable from "./AssessmentPopulationTable"

const TAB_DEFS = [
  { key: "staff", label: "Staff" },
  { key: "internal_trainee", label: "Internal Trainee" },
  { key: "external_trainee", label: "External Trainee" },
]

const InternalStaffTestStatus = () => {
  const [isLoading, setLoading] = useState(false)
  const [mainTab, setMainTab] = useState(null) // "staff" | "internal_trainee" | "external_trainee" — null until tab access loads

  // Which tabs this logged-in user is allowed to see (per-staff tab access, set in
  // Settings > General Settings > Assessment View). null = still loading.
  const [visibleTabs, setVisibleTabs] = useState(null)

  useEffect(() => {
    const loadTabAccess = async () => {
      const token = secureLocalStorage.getItem("auth_token")
      const userId = localStorage.getItem("auth_id")
      const res = await fetchNodeData(
        setLoading,
        "preassesment/settings/tabAccess",
        token
      )
      const rows = res?.success ? res.data || [] : []
      const allowed = TAB_DEFS.map(t => t.key).filter(key => {
        const row = rows.find(r => r.tab_key === key)
        if (!row || !row.is_active) return true
        const ids = row.user_ids
          ? row.user_ids.split(",").map(s => s.trim())
          : []
        return ids.includes(String(userId))
      })
      setVisibleTabs(allowed)
      setMainTab(allowed[0] || null)
    }
    loadTabAccess()
  }, [])

  return (
    <div>
      {isLoading && <Loader />}
      <Card>
        <div className="card-body">
          {/* Header */}
          <div
            className="d-flex align-items-center justify-content-between mb-3 pb-2"
            style={{ borderBottom: "1.5px solid #f0e6f8" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 8,
                  background: "linear-gradient(135deg, #752a97, #a855c9)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="fas fa-user-check text-white"
                  style={{ fontSize: 15 }}
                ></i>
              </div>
              <span className="text-purple fw-bold" style={{ fontSize: 15 }}>
                Overall Assessment View
              </span>
            </div>
          </div>

          {/* Main tabs: Staff | Internal Trainee | External Trainee — filtered by per-staff tab access */}
          <ul
            className="nav nav-tabs mb-3"
            style={{ borderBottom: "2px solid #e9ecef" }}
          >
            {TAB_DEFS.filter(
              tab => !visibleTabs || visibleTabs.includes(tab.key)
            ).map(tab => (
              <li key={tab.key} className="nav-item">
                <button
                  className={`nav-link ${
                    mainTab === tab.key ? "active fw-semibold" : "text-muted"
                  }`}
                  style={{
                    border: "none",
                    borderBottom:
                      mainTab === tab.key
                        ? "3px solid #752a97"
                        : "3px solid transparent",
                    color: mainTab === tab.key ? "#752a97" : undefined,
                    background: "transparent",
                    padding: "8px 20px",
                    fontSize: 14,
                  }}
                  onClick={() => setMainTab(tab.key)}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>

          {visibleTabs !== null && visibleTabs.length === 0 ? (
            <div className="text-center text-muted py-5">
              <i className="fas fa-lock fa-2x mb-2 d-block"></i>
              You don't have access to any tab here. Contact an admin to be
              added under Settings &gt; General Settings &gt; Assessment View.
            </div>
          ) : mainTab ? (
            <AssessmentPopulationTable population={mainTab} />
          ) : null}
        </div>
      </Card>
    </div>
  )
}

export default InternalStaffTestStatus
